import Content from '../Section/Content';
import { HeaderTitle } from '../Section/HeaderTitle';

const ThemeFive = ({ attributes, setAttributes }) => {

    const { faqData = [] } = attributes || {};


    return (
        <div className='ThemeFiveWrapper faq-container-style'>
            <HeaderTitle
                attributes={attributes}
            />
            <Content
                faqs={faqData}
                attributes={attributes}
                setAttributes={setAttributes}
            />
        </div>
    )
}

export default ThemeFive;


